import {
  PermissionGroupSelectorFormFieldDocument,
  PermissionGroupSelectorFormFieldQuery,
} from 'generated/resources/graphql'

import {
  createGraphqlDataSourceDefinition,
  useGraphqlDataSource,
} from 'modules/core/hooks/useGraphqlDataSource'

export type PermissionGroupRecord = {
  id: number
  name: string
}

const permissionGroupSelectorSourceDefinition = createGraphqlDataSourceDefinition({
  document: PermissionGroupSelectorFormFieldDocument,
  paginationType: 'infinite-scroll',
  perPage: 20,
  mapVariables: () => ({}),
  mapData: (data: PermissionGroupSelectorFormFieldQuery): PermissionGroupRecord[] =>
    data.permissions?.permissionGroupsConnection?.nodes?.map((node) => ({
      id: node.id,
      name: node.name,
    })) ?? [],
  mapPagination: (data: PermissionGroupSelectorFormFieldQuery) => ({
    total: data.permissions?.permissionGroupsConnection?.totalCount ?? 0,
    cursor: data.permissions?.permissionGroupsConnection?.pageInfo?.endCursor ?? undefined,
    hasNextPage: data.permissions?.permissionGroupsConnection?.pageInfo?.hasNextPage ?? false,
  }),
})

export const usePermissionGroupSelectorSource = () => {
  return useGraphqlDataSource(permissionGroupSelectorSourceDefinition)
}
